export default __webpack_public_path__ + "static/media/right-quote.8c480f00.svg";